export default "__VITE_ASSET__xfofGIME__"